import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faReact, faPython, faPhp, faNode, faVuejs, faDocker } from '@fortawesome/free-brands-svg-icons'

const Wrapper = styled.div`
  display: block;
  width: 100%;
  ${tw`shadow-lg relative no-underline rounded-lg px-8 py-8 md:py-15 text-white`};
  background: linear-gradient(to right, #536fd7, #19a8f4);
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &:hover {
    transform: translateY(-5px);
  }
`
const Icons = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`
const IconWrapper = () => (
  <Wrapper>
    <Icons>
      <FontAwesomeIcon icon={faReact} size="6x" />
      <FontAwesomeIcon icon={faPython} size="6x" />
      <FontAwesomeIcon icon={faPhp} size="6x" />
      <FontAwesomeIcon icon={faNode} size="6x" />
      <FontAwesomeIcon icon={faVuejs} size="6x" />
      <FontAwesomeIcon icon={faDocker} size="6x" />
    </Icons>
  </Wrapper>
)

export default IconWrapper
